import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const LOCALES = ["en", "fr", "tr"];

// Prefixes absolute in-app paths with the active locale (e.g. "/properties" -> "/fr/properties").
// Leaves external URLs, hashes and already-prefixed paths untouched.
export const localizePath = (to, lang) => {
  if (typeof to !== "string") return to;
  if (!to.startsWith("/")) return to; // external / relative / hash
  const seg = to.split("/")[1];
  if (LOCALES.includes(seg)) return to; // already localized
  const l = LOCALES.includes(lang) ? lang : "en";
  return to === "/" ? `/${l}` : `/${l}${to}`;
};

export const Link = forwardRef(({ to, ...props }, ref) => {
  const { lang } = useLang();
  return <RouterLink ref={ref} to={localizePath(to, lang)} {...props} />;
});
Link.displayName = "LocaleLink";

export default Link;
